import { Drawer } from "antd"
import Select from "react-select"
import React, { useState } from "react"
import { useSnackbar } from "notistack"
import Creatable from "react-select/creatable"

import { notifOps, useListData, usePet } from "../../modules"

import Confirm from "../reusable/confirm"
import Receive from "../reusable/receive"
import SelectLabel from "../reusable/selectLabel"
import SaleItemPricing from "../reusable/saleItemPricing"

const EditLinkedSaleItem = ({ toggle, linked = true, variant = false, visible, type: siType, itm, priceLists, accounts, onComplete }) => {
    let type = itm?.type === 'variant' ? itm?.ref ? 'Sale Item' : 'Prepared Item' : itm.type

    const [name, setName] = useState(itm?.name)
    const [category, setCategory] = useState({ label: itm?.category, value: itm?.category })
    const [income, setIncome] = useState(itm.account)
    const [form, setForm] = useState(itm?.form ? { label: itm?.form?.name, value: itm?.form?._id } : null)
    const [sp, setSp] = useState(itm?.price)
    const [string, setString] = useState('')
    const [conversionRate, setConversionRate] = useState(itm?.conversionRate ?? 1)
    const [maxDiscount, setMaxDiscount] = useState(itm?.maxDiscount ?? 0)
    const [formulaOk, setOK] = useState(true)
    const [categories, setCategories] = useState([])
    const [lists, setLists] = useState(priceLists.map(list => {
        let eq = itm?.prices?.find(entry => entry?.priceList === list?._id)
        
        list.price = (list.name === 'Cash' ? sp : eq?.price) ?? 0
        list.formula = eq?.pricingFormula ?? ''
        list.type = list.type ?? "Direct Price"

        return list
    }))

    const [{ loading: catsLoading, error: catsError }] = usePet('saleItemCategories', null, { notify: true, callback: ({ data }) => setCategories(data) })

    const [{ loading: formsLoading }, { list: forms = [] }] = useListData('inputForms', { string }, { notify: true }, 'forms', 100)

    const { enqueueSnackbar } = useSnackbar()

    const hasVariants = itm?.variants?.length > 0

    const editPrice = (vl, i) => { 
        let temp = [...lists]

        if (!isNaN(vl) && vl !== null && vl !== undefined) {
            if (temp[i].name === 'Cash')
                setSp(vl)

            temp[i].price = vl
            setLists(temp)
        } else {
            enqueueSnackbar('Please enter the a numerical value', notifOps('warning'))
        }            
    }

    const editType = (vl, i) => {
        if (siType !== 'Sale Item' && vl.label === 'Computed Price') {
            enqueueSnackbar('Non-sale items can only take a direct price', notifOps('warning'))
            return
        }

        let temp = [...lists]
        temp[i].type = vl.label
        temp[i].price = 0
        temp[i].formula = ''
        setLists(temp)
        setSp(0)
    }

    const editFormula = (vl, i) => {
        if (siType !== 'Sale Item' && vl.contains('bp')) {
            enqueueSnackbar('Non-sale items can only take a direct price', notifOps('warning'))
            return
        }

        let test = vl.replace('bp', 100)
        
        try {
            let resp = eval(test)
            if (isNaN(resp)) {
                enqueueSnackbar('Please enter a valid formula', notifOps('warning'))
            } else {
                let temp = [...lists]
                temp[i].formula = vl
                setLists(temp)
            }
        } catch (error) {
            enqueueSnackbar('Please enter a valid formula', notifOps('warning'))
        }
    }

    const evaluate = vl => {
        let test = vl.replace('bp', 100)
        
        try {
            let resp = eval(test)
            if (isNaN(resp)) {
                setOK(false)
            } else {
                setOK(true)
            }
        } catch (error) {
            setOK(false)
        }
    }
    
    const modify = e => {
        switch (e.target.name) {
            case 'name':
                setName(e.target.value)
                break

            case 'price':
                let temp = [...lists]
                setLists(temp.map(list => {
                    list.price = list.name === 'Cash' ? e.target.value : list.price
                    return list
                }))
                setSp(e.target.value)
                break

            case 'conversion-rate':
                setConversionRate(e.target.value)
                break

            case 'max-discount':
                setMaxDiscount(e.target.value)
                break

            default:
                break
        }
    }

    const callback = (_, notif, ops) => {
        onComplete(name)
        setTimeout(toggle, 300)
        notif('Sale item has been updated', ops('success'))
    }

    const [{ loading }, execute] = usePet('editSaleItem', {
        id: itm?._id, 
        name, 
        category: category?.value, 
        price: sp,
        account: income?.value,
        ref: itm?.ref?._id,
        conversionRate,
        prices: lists.map(({ _id, name, price, formula, type }) => ({ 
            name, 
            price, 
            priceList: _id,
            pricingFormula: formula, 
            pricingType: type 
        })),
        form: form?.value,
    }, { notify: true, hasFile: true, callback, manual: true, load: { msg: 'Editing sale item...' } })

    const save = () => formulaOk && Confirm({
        title: 'Save Changes?',
        message: 'Please confirm before proceeding',
        okText: 'Save Changes',
        onOk: execute
    })

    return (
        <Drawer
            closable
            maskClosable
            visible={ visible }
            onClose={ toggle }
            footer={
                <div className="w-full text-right">
                    <button disabled={ loading } onClick={ save } className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
                </div>
            }
            width="30%">
            <p className="font-extrabold text-3xl mb-0">Edit{ variant ? ' Variant' : linked ? ' Linked' : '' } Sale Item</p>  
            <div className="w-full px-3 mb-1">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                    Name
                </label>
                <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="grid-name"
                    type="text"
                    name="name"
                    value={name}
                    onChange={modify}
                    placeholder="Potatoes" />
            </div>   
            {
                siType === 'Sale Item' &&
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Conversion Rate
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-conversion-rate"
                        type="text"
                        name="conversion-rate"
                        value={ conversionRate }
                        onChange={modify}
                        placeholder="1/27" />
                </div> 
            }
            <div className="w-full px-3 mb-1">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                    Category
                </label>
                <Receive
                    loading={catsLoading}
                    error={catsError}>
                    <Creatable
                        value={category}
                        onCreateOption={ val => {
                            let temp = [...categories]
                            temp.push(val)
                            setCategories(temp)
                            setCategory({ label: val, value: val })
                        }}
                        onChange={setCategory}
                        options={categories.map(cat => ({ label: cat, value: cat }))}
                        placeholder="Select Category" />
                </Receive>
            </div>
            <div className="w-full px-3 mt-3 mb-1">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                    Sales Account
                </label>
                <Select
                    className="mb-3"
                    value={income}
                    onChange={setIncome}
                    formatGroupLabel={SelectLabel}
                    options={ accounts.filter(acc => acc.label === 'Income') }
                    placeholder="Select account" />
            </div>
            {
                !(type === 'Sale Item' || type === 'Prepared Item') && !hasVariants &&
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                        Input Form
                    </label>
                    <Select
                        value={form}
                        className="mb-3"
                        options={forms.map(frm => ({ value: frm._id, label: frm.name }))}
                        onChange={setForm}
                        isLoading={formsLoading}
                        placeholder="Select Input Form" />
                </div>
            }
            <div className="w-full px-3 mb-1">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-quantity">
                    Selling Price
                </label>
                <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="grid-sp"
                    type="number"
                    name="price"
                    onChange={ modify }
                    value={sp}
                    placeholder="XXXX" />
            </div>
            <div className="w-full px-3 mb-1">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-quantity">
                    Max Discount
                </label>
                <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="grid-md"
                    type="number"
                    name="max-discount"
                    onChange={ modify }
                    value={maxDiscount}
                    placeholder="XXXX" />
            </div>
            <div className="w-full px-3 mb-1">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                    Price Lists
                </label>
                <SaleItemPricing
                    editFormula={ editFormula }
                    editPrice={ editPrice }
                    editType={ editType }
                    lists={ lists } 
                    evaluate={ evaluate } />
            </div>
        </Drawer>
    )
}

export default EditLinkedSaleItem